import { sendEvent } from '../analytics-web-client-wrapper';
import { processEventPayload } from './process-event-payload';
export var handleEvent = function (event, 
// If passing through multiple tags, the primary tag should be first in the array.
// The primary tag is used for matching context.
tags, logger, client) {
    if (!event.payload) {
        return;
    }
    var payload = processEventPayload(event, tags);
    sendEvent(logger, client)(payload);
};
//# sourceMappingURL=handle-event.js.map